<template>
  <div id="NewJob">
    <ul class="newjob-wrap">
      <li class="newjob-item" v-for="(item, index) in newJobData" :key="index">
        <div class="newjob-inner">
          <div class="newjob-top">
            <h5 class="newjob-tit" @click="goJob(item.jobId, item.clientId)">
              {{ item.jobName }}
            </h5>
            <p class="newjob-money">
              {{ item.salaryAreaStr }}
            </p>
          </div>
          <ul class="newjob-welfare">
            <li
              class="newjob-welfare-i"
              v-for="(sonitem, sonindex) in item.treatment"
              :key="sonindex"
            >
              {{ sonitem }}
            </li>
          </ul>
          <ul class="newjob-label">
            <li class="newjob-label-item">
              <img
                src="@/assets/img/icon_loc.png"
                class="newjob-label-icon"
                alt=""
              />{{ item.areaCodeStr }}
            </li>
            <li class="newjob-label-item">
              <img
                src="@/assets/img/icon_person.png"
                class="newjob-label-icon"
                alt=""
              />{{ item.recruitmentNumber }}
            </li>
            <li class="newjob-label-item">
              <img
                src="@/assets/img/icon_education.png"
                class="newjob-label-icon"
                alt=""
              />{{ item.recruitmentTypeStr }}
            </li>
          </ul>
          <div class="newjob-b" @click="goCompany(item.clientId)">
            <div class="newjob-logo-box">
              <img :src="item.logo" class="newjob-logo" alt="" />
            </div>
            <div class="newjob-company">
              <p class="newjob-company-name">{{ item.clientName }}</p>
              <p class="newjob-company-info">
                {{ item.industryStr }}丨{{ item.companyScaleIdStr }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "NewJob",
  props: ["newJobData"],
  methods: {
    goCompany(id) {
      this.$router.push({ path: "/company", query: { id } });
    },
    goJob(id, clientId) {
      this.$router.push({
        path: "/job",
        query: { id: id, clientId: clientId },
      });
    },
  },
};
</script>
<style scoped>
.newjob-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
}
.newjob-item {
  width: 33.3%;
  padding: 0 20px 20px 0;
}
.newjob-inner {
  background: #ffffff;
  border: 1px solid #eeeeee;
  padding: 20px 20px 13px;
}
.newjob-inner:hover {
  border-color: transparent;
  box-shadow: 0px 0px 15px 0px rgba(189, 189, 189, 0.5);
}
.newjob-inner:hover .newjob-tit,
.newjob-inner:hover .newjob-company-name {
  color: #3b87ff;
}
.newjob-company-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.newjob-top {
  display: flex;
  justify-content: space-between;
}
.newjob-tit {
  color: #333;
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  flex: 1;
  cursor: pointer;
  line-height: 1.15;
}

.newjob-money {
  color: #ff6600;
  font-size: 16px;
}
.newjob-welfare,
.newjob-label {
  display: flex;
  margin: 10px 0 14px;
  overflow: hidden;
}
.newjob-welfare-i {
  background: #e8f4ff;
  border-radius: 2px;
  padding: 3px;
  font-size: 12px;
  color: #333;
  white-space: nowrap;
  margin-right: 10px;
}
.newjob-label-item {
  font-size: 12px;
  margin-right: 18px;
  display: flex;
  align-items: center;
}
.newjob-label-icon {
  width: 14px;
  height: 14px;
  margin-right: 3px;
}
.newjob-b {
  border-top: 1px dashed #e0e0e0;
  display: flex;
  margin-top: 17px;
  padding-top: 13px;
  cursor: pointer;
}
.newjob-logo-box {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
}
.newjob-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.newjob-company {
  margin-left: 12px;
  padding: 5px 0;
}
.newjob-company-info {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
}
</style>
